import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import { Link, Redirect } from 'react-router-dom'
import { FormattedMessage, FormattedNumber, FormattedDate } from 'react-intl'
import StandardList from '../common/listing/list.component.jsx'
import QuoteStatusBadge from '../quote/status.component.jsx'
import Pagination from "../common/listing/pagination.component.jsx";
import Icon from "../common/icon/icon.component.jsx";
import GlobalHelper from '../common/GlobalHelper.jsx';
import LinkWrapper from '../common/rich-text/feature-protection-wrappers/linkWrapper.component';

class QuoteList extends Component {

    constructor(props, context) {
        super(props, context)

        const contactId = this.props.contactId || ''
        this.state = {
            contactId: contactId,
            defaultContactId: '',
            noEmployee: false,
            headers: [],
            rows: [],
            activePage: 1,
            pageSize: 10,
            totalItemsCount: 0,
            contactType: "",
            accountLimit: null,
        }
        this.handlePageChange = this.handlePageChange.bind(this)
    }

    componentDidMount() {
        AppContext.getApiClient().get('/account-limits').then(res => {
            this.setState({
                accountLimit: res,
            })
        })

        if (this.state.contactId) {
            this.loadQuotesByContactId(this.state.contactId)
        }
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            contactId: nextProps.contactId
        }, () => {
            this.loadQuotesByContactId(this.state.contactId)
        })
    }

    headers() {
        return [
            <FormattedMessage
                id="customers.quotes.list.headers.id_label"
                defaultMessage="ID"
            />,
            <FormattedMessage
                id="customers.quotes.list.headers.title_label"
                defaultMessage="Title"
            />,
            <FormattedMessage
                id="customers.quotes.list.headers.value_label"
                defaultMessage="Value"
            />,
            <FormattedMessage
                id="customers.quotes.list.headers.proposed_date_label"
                defaultMessage="Proposed Date"
            />,
            <FormattedMessage
                id="customers.quotes.list.headers.created_at_label"
                defaultMessage="Created Date"
            />,
            <FormattedMessage
                id="customers.quotes.list.headers.status_label"
                defaultMessage="Status"
            />,
        ]
    }

    row(quote) {
        return [
            <span>
                <Link to={'/quotes/' + quote.id + '/edit'}>
                    {quote.identifier}
                </Link>
                <small className={"ml-2"}>{quote.poNumber}</small>
            </span>,
            <div className={this.state.contentType == "organizations" && 
            quote.contact && quote.contact.isArchived ? "text-danger" : ""}> 
                {quote.projectTitle}
            </div>,
            <FormattedNumber
                style="currency"
                currency={quote.currency}
                value={quote.totalValue}
            />,
            <span> {quote.proposedAt ? <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(quote.proposedAt)} /> :
                "-"}
            </span>,
            <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(quote.createdAt)} />,
            <QuoteStatusBadge status={quote.status} internal={true} />,
        ]
    }

    loadQuotesByContactId(contactId) {
        AppContext.getApiClient().get('/contacts/' + contactId).then(res => {
            if (res.error) {
                return
            }
            this.setState({
                noEmployee: res.type === 'organizations' && !res.attributes.primaryContactId,
                defaultContactId: res.type === 'organizations' ? res.attributes.primaryContactId : res.id,
                contactType: res.type,
            })
            let postData = {
                keywords: '*',
                objects: ['quotes'],
                fields: ['identifier', 'contact.name'],
                pageSize: this.state.pageSize,
                activePage: this.state.activePage,
                sortByField: 'createdAt',
                sortAsc: false,
                filters: {
                    contactId: res.attributes.customerAccountIds
                },
                lightResult: true,
            }
            return AppContext.getApiClient().post('/listing/search', postData)
        }).then(r => {
            this.setState({
                headers: r.data.length > 0 ? this.headers() : [],
                rows: r.data.map(q => this.row(q)),
                loading: false,
                totalItemsCount: r.metadata.totalItemsCount,
            })
        })
    }
    handlePageChange(pageNumber) {
        this.setState({
            activePage: pageNumber
        }, () => {
            this.loadQuotesByContactId(this.state.contactId)
        })
    }

    render() {
        if (this.state.rows.length < 0) {
            return <div />
        }
        return (
            <div>
                <StandardList
                    className="row pt-0"
                    smallLine={true}
                    headers={this.state.headers}
                    rows={this.state.rows}
                    footer={<div className="col-12 d-flex d-flex justify-content-between align-items-center">
                        <div>
                            <Pagination
                                className={'px-2'}
                                activePage={this.state.activePage}
                                pageSize={this.state.pageSize}
                                totalItemsCount={this.state.totalItemsCount}
                                onChange={this.handlePageChange}
                            />
                        </div>
                        {!this.state.noEmployee && this.state.accountLimit && <div>
                            <LinkWrapper
                                message={GlobalHelper.isAccountLimitExceeded(this.state.accountLimit) ?
                                    <FormattedMessage
                                        id="listing.search.invoice_document_limit"
                                        defaultMessage="Documents limit exceeded."
                                    /> : ''}
                                to={'/quotes/new?c=' + this.state.defaultContactId}
                                className={"btn btn-sm btn-primary"}
                                protectedClassName={"btn btn-sm btn-primary"}
                                premium={false}
                                protectionRule={!GlobalHelper.isAccountLimitExceeded(this.state.accountLimit)}>
                                <span>
                                    <Icon value={'plus-circle'} className={'mr-1'} />
                                    <FormattedMessage
                                        id="customers.quotes.list.new_quote_btn"
                                        defaultMessage="Create a new quote"
                                    />
                                </span>
                            </LinkWrapper>
                        </div>}
                    </div>}
                />
            </div>

        );
    }
}

export default QuoteList





// WEBPACK FOOTER //
// ./src/customer/quotelist.component.jsx